import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Navigation from "../Navigation";
import SignInPage from "../SignIn";
import SignupPage from "../SignUp";
import EventsPage from "../Events";
//import SignOutButton from "../Signout";
import AddEvents from "../AddEvents";
import CheckIn from "../CheckIn";
import HomePage from "../Home";
import EventDetails from "../EventDetails";
import FilterQuestions from "../FilterQuestions";
import Challenges from "../Challenges";
import UserProfile from "../UserProfile";

import FormPage from "../Form";
import TeamMemberPage from "../TeamMember";
import { withAuthentication } from "../Session";

import * as ROUTES from "../../constants/routes";
import allTeammembers from "../all-teammembers";
import Consultations from "../Consultations";

class App extends Component {

  render() {
    return (
      <Router>
        <Navigation />
        <Route exact path={ROUTES.HOME} component={HomePage} />
        <Route exact path={ROUTES.SIGN_UP} component={SignupPage} />
        <Route exact path={ROUTES.SIGN_IN} component={SignInPage} />
        <Route exact path={ROUTES.EVENTS} component={EventsPage} />
        <Route exact path={ROUTES.ADDEVENT} component={AddEvents} />
        <Route exact path={ROUTES.CHECKIN} component={CheckIn} />
        <Route exact path={ROUTES.EVENTDETAILS} component={EventDetails} />
        <Route
          exact
          path={ROUTES.FILTERQUESTIONS}
          component={FilterQuestions}
        />
        <Route exact path={ROUTES.CHALLENGES} component={Challenges} />
        <Route exact path={ROUTES.USERPROFILE} component={UserProfile} />
        <Route exact path={ROUTES.FORM} component={FormPage} />
        <Route exact path={ROUTES.TEAMMEMBER} component={TeamMemberPage} />
        <Route exact path={ROUTES.ALLTEAMMEMBERS} component={allTeammembers} />
        <Route exact path={ROUTES.CONSULTATIONS} component={Consultations} />
        {/* <Route path={ROUTES.SIGN_IN} component={SignInPage} />
                <Route path={ROUTES>ROUTES.HOME} component={HomePage} /> */}
      </Router>
    );
  }
}

export default withAuthentication(App);
